import React from "react";

export function WB_MediaVideo({}) {
    return <div>
        WB_MediaVideo
    </div>
}